/**
 * Dashboard responsive modes (CU-868m4dmaq, PRD FR-030). A window this width or narrower is in Mobile mode:
 * one full-width column, no drag, resize, Personalize or Maximize. A wider window is in Tablet / Full Browser
 * mode, an open grid the student can edit. The boundary is the app-wide phone breakpoint (`$isMobile` in
 * plugins/app-utilities.js), so phones up to 768 px keep full-width widget lists (CU-868ma1ufw).
 */
export const MOBILE_MODE_MAX_WIDTH = 768;

/**
 * @param {number} width Window width in CSS pixels.
 * @returns {boolean}
 */
export function isMobileModeWidth(width) {
    return width <= MOBILE_MODE_MAX_WIDTH;
}
